import { render } from "./FilterContent.vue?vue&type=template&id=37f1c09c&ts=true"
import script from "./FilterContent.vue?vue&type=script&lang=ts"
export * from "./FilterContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__